import React from 'react';
import { useTranslation } from 'react-i18next';
import DividerComponent from 'components/Divider/Divider';
import { Header } from 'components/Text';
import AddPrivilege from './AddPrivilege';
import PendingPrivilegeList from './PendingPrivilegeList';
import PrivilegeList from './PrivilegeList';
export default function AccessManagement() {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t('access_management.access_management')), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(AddPrivilege, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(PrivilegeList, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(PendingPrivilegeList, null));
}